// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2VAYo","itemTitle":"ClientEmergencyInfo_itemTitle__15568","itemText":"ClientEmergencyInfo_itemText__3Lf5K"};